<template>
  <div :class="{'mobileView': mobileView}">
    <course-sidebar :posts="posts" :course-id="courseId" :post-id="postId"
      :chapter-id="chapterId" :chapter-path-var="chapterPathVar"
      :course-name="courseName" @completedStatus="postCompletedStatus"
      @courseData="getAllCourse">
    </course-sidebar>
    <div class="col-md-7 offset-md-4 pt-md-5 pt-3 content">
      <a href="#"
        @click.prevent="gaTrackLink('Lesson', 'Click Back to Course', '', '/course/' + courseId)"
        class="mb-4 d-none d-md-block">
        <span class="material-icons align-bottom"> keyboard_arrow_left </span> 回課程頁
      </a>
      <div class="d-md-none d-flex justify-content-between align-items-center mb-3">
        <a href="#"
          @click.prevent="gaTrackLink('Lesson', 'Click Back to Course', '', '/course/' + courseId)">
          <span class="material-icons align-bottom"> keyboard_arrow_left </span> 回課程頁
        </a>
        <span class="badge badge-light text-muted px-4 py-2 font-weight-normal"
          style="font-size: 14px">{{ chapterName }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">{{ postName }}</h3>
        <span class="badge badge-light text-muted px-4 py-2
          font-weight-normal d-none d-md-inline-block"
          style="font-size: 14px">{{ chapterName }}
        </span>
      </div>
     </div>
    <div id="postContent" class="col-md-7 offset-md-4 content"
      v-if="postData" style="min-height: 300px;">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div>
        <p class="text-muted">{{ postData.date }}</p>
        <videoPlayer v-if="postData.video_url && postData.video_url !== ''"
          :video-data="postData"></videoPlayer>
        <audioPlayer v-if="postData.audio_url && postData.audio_url !== ''"
          :audio-data="postData" :scroll="scollPosition"></audioPlayer>
        <div class="row no-gutters justify-content-center course-content mb-5">
          <div class="col-md-10">
            <courseContent :content="postData.content"></courseContent>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-7 offset-md-4 pt-md-5 pt-3 content" v-if="postData">
      <div class="d-flex flex-wrap border-top border-bottom
        justify-content-between py-4 align-items-center">
        <a href="#"
          @click.prevent="gaTrackLink('Lesson', 'Click Back to Course', '', '/course/' + courseId)"
          class="d-md-block d-none">
          <span class="material-icons align-bottom"> keyboard_arrow_left </span> 回課程頁
        </a>
        <div class="btn-w-100">
          <a target="_blank" :href="postData.webinar.url"
            class="btn btn-primary px-5 completedBtn mb-md-0 mb-3 mt-lg-0 mt-md-3 text-nowrap"
            v-if="postData.webinar && postData.webinar.url && postData.webinar.url !== ''"
            :disabled="zoomStatus(postData.webinar.opened_at.timestamp,
              postData.webinar.closed_at.timestamp) || isLoading"
            :class="{'disabled': zoomStatus(postData.webinar.opened_at.timestamp,
              postData.webinar.closed_at.timestamp) || isLoading}">前往 ZOOM 上課
          </a>
          <button v-if="postData.webinar && postData.webinar.url && postData.webinar.url !== ''"
            class="btn btn-primary completedBtn mt-lg-0 mt-md-3"
            @click="completedCourse"
            :disabled="isZoomCompleteBtn(postData.webinar.closed_at.timestamp)
              || nowPostisCompleted"
            :class="{'disabled': isZoomCompleteBtn(postData.webinar.closed_at.timestamp)
              || nowPostisCompleted || isLoading}">
            {{ nowPostisCompleted? '已完成' : '完成' }}
          </button>
          <!-- 不是 ZOOM -->
          <button v-else class="btn btn-primary completedBtn"
            @click="completedCourse" :disabled="nowPostisCompleted || isLoading"
            :class="{'disabled': nowPostisCompleted || isLoading}">
            {{ nowPostisCompleted? '已完成' : '完成' }}
          </button>
        </div>
      </div>
      <div id="postComments">
        <comment :post-name="postName" :loading="isLoading"
        :admin-auth="adminAuth" :user-pic="loginUserPic"
        :user-id="loginUserId" :scope="postId" entity="Posts" />
      </div>
    </div>
    <div class="d-md-flex ml-auto course-next-back position-fixed"
      :class="nextBarShow" v-if="allPosts.length > 0">
      <button class="btn btn-custom-md btn-sm btn-outline-secondary
        px-md-5 mx-md-3 d-flex align-items-center btn-prev"
        @click="goPreOrNext('postPrev')">
        <span class="material-icons mr-2">
          arrow_back
        </span>
          {{ postPrev !== ''? '上一堂' : '回課程頁'}}
      </button>
      <button class="btn btn-custom-md btn-sm btn-secondary
        px-md-5 d-flex my-0 align-items-center"
        @click="goPreOrNext('postNext')">
        {{ postNext !== ''? '下一堂' : '回課程頁'}}
        <span class="material-icons ml-2">
          arrow_forward
        </span>
      </button>
    </div>
    <a class="mr-0 d-md-none d-inline-block
      position-fixed change-font-btn" href="#" @click.prevent="changeFontModal = true">
      <span class="material-icons fa-video-library"> format_size </span>
    </a>
    <bottom-modal v-if="changeFontModal"></bottom-modal>
  </div>
</template>
<script>
import videoPlayer from '../components/VideoPlayer';
import audioPlayer from '../components/AudioPlayer';
import courseContent from '../components/CourseContent';

export default {
  name: 'PostDetail',
  props: {
    posts: String,
    courseId: String,
    courseName: String,
    chapterPathVar: String,
    postPathVar: String,
    chapterId: String,
    postId: String,
    postName: String,
    chapterName: String,
    loginUserId: String,
    loginUserPic: String,
    adminAuth: String, // 確認是否有 Admin 權限（可刪除所有人的留言）
  },
  components: {
    videoPlayer,
    audioPlayer,
    courseContent,
  },
  data() {
    return {
      postData: {},
      isLoading: true,
      courseData: {},
      allPosts: [],
      nowPostisCompleted: false, // 此單元是否已經完成
      nextBarShow: 'd-flex',
      scollPosition: 0,
      preOrNextStatus: '',
      mobileView: false,
      scrollContentData: {
        first: false,
        height: 0,
        twentyfifth: false,
        fifty: false,
        seventyfifth: false,
        onehundred: false,
      },
      scrollCommentData: {
        height: 0,
        send: false,
      },
      changeFontModal: false, // 改變字級大小的 Modal 顯示
    };
  },
  watch: {
    changeFontModal(val) {
      val ? $('body').addClass('overflow-hidden') : $('body').removeClass('overflow-hidden');
    },
  },
  methods: {
    getPostDetail() {
      const vm = this;
      vm.isLoading = true;
      axios.get(`/api/course/${vm.courseId}/chapter/${vm.chapterPathVar}/post/${vm.postPathVar}`).then((res) => {
        vm.postData = res.data.data;
        vm.isLoading = false;
      }).catch((err) => {
        vm.isLoading = false;
        flash(`讀取錯誤${err}`, 'danger');
      });
    },
    getAllCourse(value) {
      const vm = this;
      vm.courseData = value;
      const chapters = value.chapters.sort((a, b) => a.sort - b.sort);
      chapters.forEach((chapter) => {
        vm.postSort(chapter.posts).forEach((post) => {
          if (post.active) {
            vm.allPosts.push({ ...post, chapterVar: chapter.path_var });
          }
        });
      });
    },
    completedCourse() { // 標記課程為完成
      const vm = this;
      axios.get(`/api/course/${vm.courseId}/chapter/${vm.chapterPathVar}/post/${vm.postPathVar}/completed`).then((res) => {
        if (res.status === 200) {
          vm.gaTrackEvent('Lesson', 'Complete Lesson', vm.postName);
          if (vm.postNext !== '') {
            setTimeout(() => {
              window.location.href = `/course/${vm.courseId}/chapter/${vm.postNext.chapterVar}/post/${vm.postNext.path_var}`;
            }, 500);
          } else {
            flash('已經是最後一堂課程囉！5 秒後重整頁面', 'warning');
            window.location.reload();
            setTimeout(() => {
              window.location.href = `/course/${vm.courseId}/chapter/${vm.postNext.chapterVar}/post/${vm.postNext.path_var}`;
            }, 5000);
          }
        }
      });
    },
    zoomStatus(openedAt, closedAt) {
      // 判斷
      const now = this.$moment(new Date()).format('X');
      const reallyOpenTime = openedAt - 30 * 60; // 開始時間的前 30 分鐘
      const inThisTime = now < closedAt && reallyOpenTime < now;
      return !(inThisTime);
    },
    isZoomCompleteBtn(closedAt) { // 是 ZOOM 課程，結束後才開始的完成按鈕
      const now = this.$moment(new Date()).format('X');
      return now < closedAt;
    },
    postCompletedStatus(value) {
      if (value === 'check_circle') {
        this.nowPostisCompleted = true;
      } else {
        this.nowPostisCompleted = false;
      }
    },
    handleScroll() {
      const vm = this;
      const scrollTop = Math.max(window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop);
      if (scrollTop > vm.scollPosition) {
        vm.nextBarShow = 'd-none';
      } else {
        vm.nextBarShow = 'd-flex';
      }
      setTimeout(() => {
        vm.scollPosition = scrollTop;
      }, 100);

      if (!vm.scrollContentData.first) {
        vm.scrollContentData.height = document.querySelector('#postContent').clientHeight;
        vm.scrollCommentData.height = document.querySelector('#postComments').offsetParent.offsetTop;
        vm.scrollContentData.first = true;
      }
      // page scroll for ga
      const scrollPercent = (scrollTop) / (vm.scrollContentData.height - 300);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded <= 105) {
        if (scrollPercentRounded < 50 && scrollPercentRounded > 25) {
          if (!vm.scrollContentData.twentyfifth) {
            vm.gaTrackEvent('Lesson', 'Scroll', vm.postName, 25);
            vm.scrollContentData.twentyfifth = true;
          }
        }
        if (scrollPercentRounded < 75 && scrollPercentRounded > 50) {
          if (!vm.scrollContentData.fifty) {
            vm.gaTrackEvent('Lesson', 'Scroll', vm.postName, 50);
            vm.scrollContentData.fifty = true;
          }
        }
        if (scrollPercentRounded < 100 && scrollPercentRounded > 75) {
          if (!vm.scrollContentData.seventyfifth) {
            vm.gaTrackEvent('Lesson', 'Scroll', vm.postName, 75);
            vm.scrollContentData.seventyfifth = true;
          }
        }
        if (scrollPercentRounded === 100 || scrollPercentRounded > 95) {
          if (!vm.scrollContentData.onehundred) {
            vm.gaTrackEvent('Lesson', 'Scroll', vm.postName, 100);
            vm.scrollContentData.onehundred = true;
          }
        }
      }
      if (vm.scrollCommentData.height < scrollTop && !vm.scrollCommentData.send) {
        vm.gaTrackEvent('Lesson', 'Scroll - Comment', vm.postName);
        vm.scrollCommentData.send = true;
      }
    },
    goPreOrNext(type) {
      const vm = this;
      if (vm[type] === '') {
        window.location.href = `/course/${vm.courseId}`;
      } else {
        const gaAction = type === 'postPrev' ? 'Click Previous' : 'Click Next';
        vm.gaTrackEvent('Lesson', gaAction, vm.postName);
        window.location.href = `/course/${vm.courseId}/chapter/${vm[type].chapterVar}/post/${vm[type].path_var}`;
      }
    },
  },
  computed: {
    postNext() { // 找出按下完成按鈕後的下一堂課
      const vm = this;
      const index = vm.checkItemActive(this.allPosts).findIndex((post) => post.id === vm.postId);
      const nextIndex = index + 1;
      if (nextIndex < this.allPosts.length) {
        return this.allPosts[nextIndex];
      }
      return '';
    },
    postPrev() { // 找出按下完成按鈕後的上一堂課
      const vm = this;
      const index = vm.checkItemActive(this.allPosts).findIndex((post) => post.id === vm.postId);
      const preIndex = parseInt(index, 10) - 1;
      if (preIndex > -1) {
        return this.allPosts[preIndex];
      }
      return '';
    },
  },
  mounted() {
    const vm = this;
    vm.getPostDetail();
    // vm.getCourse();
    if (window.innerWidth < 768) {
      vm.mobileView = true;
      window.addEventListener('scroll', vm.handleScroll, true);
    }
    vm.$bus.$on('changeFontModalShow', (val) => {
      vm.changeFontModal = val;
    });
  },
};
</script>

<style scoped>
  .mobileView {
    margin-bottom: 72px;
  }
  @media (max-width: 768px) {
    .md-fixed-botoom .course-content {
      margin-bottom: 68px;
    }
  }
  .completedBtn {
    width: 240px;
    max-width: 240px;
  }
  @media (max-width: 768px) {
    .completedBtn {
      width: 100%;
      max-width: 100%;
    }
    .btn-w-100 {
      width: 100%;
      max-width: 100%;
    }
  }

  @media screen and (min-width: 769px) {
    .course-next-back {
      top: 8px;
      right: 15px;
      z-index: 1060;
    }
  }
  @media screen and (max-width: 768px) {
    .course-next-back {
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      background: white;
      z-index: 1060;
    }
    .btn-custom-md {
      width: 100%;
      border-radius: 0px;
      padding-top: 1rem;
      padding-bottom: 1rem;
      justify-content: center;
      border-left: 0px;
      border-right: 0px;
    }
  }
  .btn-prev.active {
    background: white;
  }
  .change-font-btn {
    right: 50px;
    top: 14px;
    z-index: 1080;
  }
  .modal-open  .change-font-btn, .sidebar-open .change-font-btn {
    display: none !important;
  }
</style>
